import { render, staticRenderFns } from "./CostofsalesListEditor.vue?vue&type=template&id=5bb126bb&scoped=true&"
import script from "./CostofsalesListEditor.vue?vue&type=script&lang=js&"
export * from "./CostofsalesListEditor.vue?vue&type=script&lang=js&"
import style0 from "./CostofsalesListEditor.vue?vue&type=style&index=0&id=5bb126bb&prod&scoped=true&lang=css&"
import style1 from "./CostofsalesListEditor.vue?vue&type=style&index=1&id=5bb126bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb126bb",
  null
  
)

export default component.exports